import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRewardRoute } from '@/common/reward/route.registry';
import { InjectionFeature } from '@/common/reward/types';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_SCRATCH } from './router';

export default registerRouteForModule(router);

registerRewardRoute(InjectionFeature.ScratchTicket, {
    routeToInfoPage: () => ({ name: ROUTE_NAME_SCRATCH.TICKET.INDEX }),
    routeToIndexPage: () => ({ name: ROUTE_NAME_SCRATCH.TICKET.INDEX })
});

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'ScratchTicket',
        name: 'Scratch Ticket',
        icon: 'fas fa-eraser',
        route: { name: ROUTE_NAME_SCRATCH.TICKET.INDEX }
    }
]);
